import { setCookie } from '@cian/utils/lib/browser/cookie';
import { IRegion } from '../../types/region';

export function setRegionCookie(region: IRegion) {
  if (region && typeof window !== 'undefined' && region.id !== 0) {
    setCookie('session_region_id', String(region.id), { secure: false });
    setCookie('session_main_town_region_id', String(region.id), { secure: false });
  }
}
